import { routes } from "@/common/utils/routes";
import { VerifiedIcon } from "components/UI/VerifiedIcon";
import { Link } from "react-router-dom";
import DefaultUserIcon from "@/common/images/icons/profileIcon.svg?react";
import { useMemo, memo } from "react";
import "./UserInfo.scss";

export const UserInfo = memo((props: {
  name?: string;
  userpic?: string;
  verified: boolean;
  isStudio: boolean;
  userId?: string;
}) => {
  if (!props.name) {
    return <></>;
  }

  const avatar = useMemo(() => {
    if (!props.userpic) {
      return <DefaultUserIcon className="avatarDefault" />;
    }

    return (
      <img
        loading="lazy"
        src={props.userpic}
        alt="user avatar"
      />
    );
  }, [props.userpic]);

  return (
    <div className="userInfo">
      <Link
        className="userAvatar"
        to={routes.user(props.userId || props.name)}
        target="_blank"
        aria-label="Open user profile page"
        title="Open user profile page"
      >
        {avatar}
        <span className="userName">{props.name}</span>
        {props.verified && <VerifiedIcon title={`Video from a verified ${props.isStudio ? "channel" : "user"}`} isStudio={props.isStudio} />}
      </Link>
    </div>
  );
});
